import React from 'react';
import CartInputField from './CartInputField';

function CartSummary(props) {
/* 
  function convert(num) {
    //console.log(num);
    return num.toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
*/
  //console.log(props);
  return (
    <div className="riepilogo_cart">
      <div className="titolo_riepilogo_cart">
        <h2>Riepilogo</h2>
      </div>

      <div className="elenco_riepilogo_cart">
        <div className="riga_riepilogo_cart">
          <p className="sx_riepilogo_cart">Consegna entro il:</p>
          <p className="dx_riepilogo_cart">
            {props.cartData.carrello.data_consegna}
          </p>
        </div>
        <div className="riga_riepilogo_cart">
          <p className="sx_riepilogo_cart">Totale prodotti:</p>
          <p className="dx_riepilogo_cart">
            &euro; {props.convert(props.cartData.carrello.totale_prodotti_euro)}
          </p> 
        </div>
        <div className="riga_riepilogo_cart">
          <p className="sx_riepilogo_cart">Spese di spedizione:</p>
          {props.cartData.carrello.costo_spedizione > 0 ? (
            <p className="dx_riepilogo_cart">
              &euro; {props.convert(props.cartData.carrello.costo_spedizione)}
            </p>
          ) : (
            <p className="dx_riepilogo_cart">gratuite</p>
          )}
        </div>
        {props.cartData.carrello.costo_pagamento > 0 ? (
          <div className="riga_riepilogo_cart">
            <p className="sx_riepilogo_cart">Costo pagamento:</p>
            <p className="dx_riepilogo_cart">
              &euro; {props.convert(props.cartData.carrello.costo_pagamento)}
            </p>
          </div>
        ) : null}
        {props.cartData.carrello.totale_sconto > 0 ? (
          <div className="riga_riepilogo_cart">
            <p className="sx_riepilogo_cart">Totale sconto:</p>
            <p className="dx_riepilogo_cart">
              &euro; {props.convert(-props.cartData.carrello.totale_sconto)}
            </p>
          </div>
        ) : null}
        {props.cartData.carrello.credito_utilizzabile > 0 &&
        props.cartData.carrello.usa_credito === "1" ? (
          <div className="riga_riepilogo_cart">
            <p className="sx_riepilogo_cart">Credito:</p>
            <p className="dx_riepilogo_cart">
              &euro;{" "}
              {props.convert(-props.cartData.carrello.credito_utilizzabile)}
            </p>
          </div>
        ) : null}
        <div className="riga_riepilogo_cart">
          <p className="sx_riepilogo_cart">Totale:</p>
          <p className="dx_riepilogo_cart">
            &euro; {props.convert(props.cartData.carrello.totale_euro)}
          </p>
        </div>
        {props.cartData.carrello.credito_utilizzabile > 0 ? (
          <CartInputField
            required={false}
            type="checkbox"
            lbl="Non voglio usare il mio credito"
            name="NoCreditUse"
            value={props.creditOption}
            change={props.changeCreditOption}
            cssClass="mio_credito_cart"
            labelRight={true}
            errList={props.errList}
          />
        ) : null}
        <div className="clear"></div>
      </div>
    </div>
  );
}

export default CartSummary;